"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Button_1 = __importDefault(require("@mui/material/Button"));
exports.default = ({ commentNumber }) => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
        height: '13px',
        p: '2px',
        borderRadius: '2px',
        fontWeight: 700,
        fontSize: '9px',
        color: 'white',
        bgcolor: 'rgba(0, 0, 0, 0.2) !important',
    }, onClick: () => (window.location.href = `/fondee/report/?commentId=${commentNumber}`) }, { children: "\uC2E0\uACE0" })));
